export function PlatformStatusCheckMark() {
  return (
    <svg
      className="-mt-2 -ml-0.5 size-2.5 text-green-500"
      viewBox="0 0 10 10"
      fill="currentColor"
    >
      <path
        d="M1.5 5.5L3.5 7.5L8.5 2.5"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function PlatformStatusXMark() {
  return (
    <svg
      className="-mt-2 -ml-0.5 size-2.5 text-red-500"
      viewBox="0 0 10 10"
      fill="none"
    >
      <path
        d="M2 2L8 8M8 2L2 8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}
